export default __webpack_public_path__ + "static/media/Versions - vs Official vs Films_04.f57cea37.jpg";